import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { taskService } from '@/services/api';
import { QUERY_KEYS } from '@/services/queryClient';

/**
 * Returns the set of task IDs the current user has picked for today.
 */
export function useTodaysPickedTaskIds(): Set<string> {
  const { data } = useQuery({
    queryKey: QUERY_KEYS.todaysTasks,
    queryFn: () => taskService.getTodaysPicks(),
    staleTime: 30000,
  });

  return useMemo(
    () => new Set((data?.tasks ?? []).map((task) => task.id)),
    [data?.tasks]
  );
}
